export const INSERT_DIVIDER_BUTTON = 'insert-divider-button';

export const ROOT = 'divider';

export const PLUGIN_TOOLBAR_DIVIDER_SIZE_BUTTON = 'plugin-toolbar-divider-size-button';
export const SIZE_DROPDDOWN_OPTION_SMALL = 'size-dropdown-option-small';
export const SIZE_DROPDDOWN_OPTION_MEDIUM = 'size-dropdown-option-medium';
export const SIZE_DROPDDOWN_OPTION_LARGE = 'size-dropdown-option-large';

export const PLUGIN_TOOLBAR_DIVIDER_STYLE_BUTTON = 'plugin-toolbar-divider-style-button';
export const STYLE_DROPDOWN_OPTION_SINGLE = 'style-dropdown-option-single';
export const STYLE_DROPDOWN_OPTION_DOUBLE = 'style-dropdown-option-double';
export const STYLE_DROPDOWN_OPTION_DASHED = 'style-dropdown-option-dashed';
export const STYLE_DROPDOWN_OPTION_DOTTED = 'style-dropdown-option-dotted';
